<template>
  <span v-if="isHeader">
    <!--  -->
    Actions
  </span>
  <div v-else>
    <dropdown v-if="$route.meta.isAdmin">
      <dropdown-action icon="search" @click="onClickView"
        >View {{ type }}</dropdown-action
      >
      <dropdown-action icon="chart" @click="onClickViewResults"
        >View Results</dropdown-action
      >
      <dropdown-action icon="edit" @click="onClickEdit"
        >Edit {{ type }}</dropdown-action
      >
      <dropdown-action icon="delete" @click="onClickDelete" v-if="canDelete"
        >Delete {{ type }}</dropdown-action
      >
    </dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown'
import DropdownAction from '@/components/DropdownAction'

import TrAction from '@/components/TableRowAction'

import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import UserHasPermission from '@/mixins/UserHasPermission'
export default {
  name: 'document-actions',

  props: {
    rowData: Object,
    id: [String, Number],
    routePath: String,
    type: {
      type: String,
      default: 'Article'
    },
    previewRoute: {
      type: String,
      default: 'AdminDocumentPreview'
    },
    deleteAction: {
      type: String,
      default: 'News/delete'
    },
    publishAction: {
      type: String,
      default: 'News/approve'
    },
    rejectAction: {
      type: String,
      default: 'News/reject'
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    userCanAdd() {
      return this.userHasPermission('add_edit_news')
    },
    userCanPublish() {
      return this.userHasPermission('publish_news')
    }
  },

  methods: {
    onClickView() {
      this.$router.push({
        name: 'AdminPollsView',
        params: { id: this.id }
      })
    },
    onClickViewResults() {
      this.$router.push({
        name: 'AdminPollsResults',
        params: { id: this.id }
      })
    },
    onClickEdit() {
      this.$router.push({
        name: this.routePath,
        params: { id: this.id }
      })
    },

    onClickActivate() {
      this.$store.dispatch('Banner/setStatus', {
        status: 'active',
        id: this.id
      }).then(() => {
        this.$emit('tableUpdate')
      })
    },

    onClickDeactivate() {
      this.$store.dispatch('Banner/setStatus', {
        status: 'inactive',
        id: this.id
      }).then(() => {
        this.$emit('tableUpdate')
      })
    },

    onClickDelete() {
      const vm = this;
      this.$store.dispatch('createDialog', {
        confirm: () => {
          vm.$store.dispatch(vm.deleteAction, vm.id).then(() => {
            vm.$store.dispatch("notifications/create", {
                body: "The poll has been deleted",
                type: "success"
              });
            vm.$emit('tableUpdate')
          })
        }
      })
    }
  },

  data() {
    return {
      rejectionReason: '',
      rejectModalOpen: false
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin, UserHasPermission]
}
</script>
